import React from 'react'

import clsx from 'clsx'

import Button from 'components/Button'

import classes from './Tab.module.scss'

const Tab = ({ className, handleClick, selected, label, ...rest }) => (
  <Button
    className={clsx('Tab', classes.root, className)}
    component="a"
    onClick={handleClick}
    aria-selected={selected}
    role="tab"
    {...rest}
  >
    <span className={classes.wrapper}>{label}</span>
  </Button>
)

export default Tab
